module.exports = __webpack_public_path__ + "img/pocket waist seam.eb3f7ebb.png";